import i18n from 'i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { saveTmsSettings } from '../data-provider/save-settings';
import { CACHE_KEYS } from '../types';

export const useSaveTMSSettings = ({ customerKey }: { customerKey: number }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveTmsSettings,
    onError: () => {
      showNotification({ message: i18n.t('translation:default.fields.failedToSave'), type: NOTIFICATION_TYPES.ERROR });
    },
    onSuccess: () => {
      showNotification({
        message: i18n.t('translation:default.fields.tmsSettingsSuccessfullySaved'),
        type: NOTIFICATION_TYPES.SUCCESS,
      });
      queryClient.invalidateQueries({
        queryKey: CACHE_KEYS.settings(customerKey),
      });
    },
  });
};
